import { Component, EventEmitter, Input, OnInit, OnChanges, SimpleChanges, Output, ViewChild, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BatchService } from '../../../../qrcode/batchstamp/batch.service';
import { ToastrService } from 'ngx-toastr';
import { CratingService } from '../../../../qrcode/batchstamp/crating/services/crating.service';
import { Subject } from 'rxjs/Subject';
import { debounce } from 'lodash';
import { IOption } from 'ng-select';
import { TranslateService } from '@ngx-translate/core';
// declare function clickTracking(regionName: any, contentName: any, target: any, payload: any);
declare var $: any;

@Component({
  selector: 'modal-crating-box',
  templateUrl: './modal-crating-box.component.html',
  styles: [``],
  styleUrls: ['./modal-crating-box.css'],
  providers: [CratingService],
})
export class ModalCratingBoxComponent implements OnInit, OnChanges, OnDestroy {
  @Output('hideCrating') hideCrating = new EventEmitter();
  @Input() detail: any = {};
  @Input() list_prods: any = [];
  @Input() serial: any = '';
  @Input() boxNote: any = '';
  @ViewChild('boxRetalStamps') boxRetalStamps;
  @Output('messageCrating2') messageCrating2 = new EventEmitter();
  @Output('reloadListStampParent') reloadListStampParent = new EventEmitter();
  title = '';
  no_product = 'assets/images/no_product.png';
  no_image = 'assets/images/no-image.png';
  addContent = '';
  listContent = [];
  listContentTitle = [];
  unsubscribe$ = new Subject<void>();
  totalStatus;
  groupItems = [];
  waringListContent = '';
  stampList = [];
  errMess = [];
  warningMess = [];
  boxStampMess = '';
  boxStampMessWarring = '';
  public user: any;

  // TEM LẺ - arrays kết quả 2 cột
  errorListStampSingle: any[] = [];
  successListStampSingle: any[] = [];

  // DẢI TEM - arrays kết quả 2 cột
  errorCodeListStamp: any[] = [];
  successCodeListStamp: any[] = [];

  // DẢI TEM - 3 input inline
  prefixInput = '';
  serialFirstInput = '';
  serialLastInput = '';
  formCratingBatch: FormGroup = this.fb.group({
    is_cratingStampsSingle: [true],
    is_cratingStampsList: [false],
    stampCode: [''],
    stampCodeList: this.fb.array([]),
    note: [null],
    quantityPackage: [
      null, [Validators.pattern(/^[0-9]*$/)]
    ]
  });
  isReadmore: Boolean = false;
  boxTypeList: Array<IOption> = [
    {
      value: '0',
      label: 'Box',
    },
    {
      value: '1',
      label: 'Planet',
    },
    {
      value: '2',
      label: 'Container',
    },
  ];
  timeout: any = null;

  // results$: Observable<any>
  constructor(
    private fb: FormBuilder,
    private batchService: BatchService,
    private toastr: ToastrService,
    private cratingService: CratingService,
    private translate: TranslateService
  ) {
    this.user = JSON.parse(localStorage.getItem('User'));
    this.searchCode = debounce(this.searchCode, 1000);
  }

  ngOnInit() {
    this.title = this.translate.instant('DONG_THUNG');
    this.initSelect2();
    this.translate.onLangChange.subscribe(() => {
      this.title = this.translate.instant('DONG_THUNG');
      this.initSelect2();
    });

    this.getListBoxType();

    $('#crating-box').on('show.bs.modal', () => {
      this.resetFormOnOpen();
    });
  }

  resetFormOnOpen() {
    this.listContent = [];
    this.removeCodeListAll();
    this.formCratingBatch.get('stampCode').setValue(this.serial || '');
    this.formCratingBatch.get('note').setValue(this.boxNote || null);
    this.formCratingBatch.get('is_cratingStampsSingle').setValue(true);
    this.formCratingBatch.get('is_cratingStampsList').setValue(false);
    
    // Clean up arrays
    this.errorListStampSingle = [];
    this.successListStampSingle = [];
    this.errorCodeListStamp = [];
    this.successCodeListStamp = [];
    
    // Clean up text inputs
    this.addContent = '';
    this.prefixInput = '';
    this.serialFirstInput = '';
    this.serialLastInput = '';
    this.msgErrorTotalStamp = '';
    
    this.calculateTotalStamp();
  }

  ngOnDestroy() {
    $('#crating-box').off('show.bs.modal');
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['serial'] && this.serial) {
      this.formCratingBatch.get('stampCode').setValue(this.serial);
    }
    if (changes['boxNote'] && this.boxNote) {
      this.formCratingBatch.get('note').setValue(this.boxNote);
    }
  }

  initSelect2() {
    $('#crating_type').select2({
      placeholder: this.translate.instant('CRATING_VUI_LONG_CHON'),
      allowClear: false,
      minimumResultsForSearch: -1,
    });
  }

  getListBoxType() {
    this.cratingService.listBoxType().subscribe(
      (res) => {
        if (res.code === 1) {
          this.boxTypeList = res.data.map((item) => {
            return {
              value: item.type,
              label: item.name,
            };
          });
        } else {
          this.boxTypeList = [];
        }
      },
      (err) => {
        this.boxTypeList = [];
        console.log(err);
      }
    );
  }

  newCodeListScan(prefix, serialFirst, serialLast): FormGroup {
    return this.fb.group({
      prefix: prefix,
      serialFirst: serialFirst,
      serialLast: serialLast,
      data: [],
      mess: '',
    });
  }

  backToList(data = {}) {
    this.listContent = [];
    this.removeCodeListAll();
    this.formCratingBatch.get('stampCode').setValue(this.serial || '');
    this.formCratingBatch.get('note').setValue('');
    this.formCratingBatch.get('is_cratingStampsSingle').setValue(true);
    this.formCratingBatch.get('is_cratingStampsList').setValue(false);
    
    // Clean up arrays
    this.errorListStampSingle = [];
    this.successListStampSingle = [];
    this.errorCodeListStamp = [];
    this.successCodeListStamp = [];
    
    // Clean up text inputs
    this.addContent = '';
    this.prefixInput = '';
    this.serialFirstInput = '';
    this.serialLastInput = '';
    this.msgErrorTotalStamp = '';
    
    // Recalculate total
    this.calculateTotalStamp();
    
    this.hideCrating.emit(data);
  }

  changeReadMore(i, e) {
    // this.isReadmore = e;
    this.formCratingBatch.value.stampCodeList[i].isReadmore = e;
  }

  submitFormConfirm(data_post: any) {
    setTimeout(() => {
      if (this.errMess.length > 0 || this.errorListStampSingle.length > 0) {
        this.toastr.warning(this.translate.instant('CRATING_TEM_LE_DANG_BI_LOI'), this.translate.instant('CRATING_THONG_BAO_CHAM'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
        return;
      }

      if (this.errorCodeListStamp.length > 0) {
        this.toastr.warning(this.translate.instant('CRATING_TEM_DAI_DANG_BI_LOI'), this.translate.instant('CRATING_THONG_BAO_CHAM'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
        return;
      }


      if (
        this.formCratingBatch.value.is_cratingStampsSingle === false &&
        this.formCratingBatch.value.is_cratingStampsList === false
      ) {
        this.toastr.warning(
          this.translate.instant('CRATING_BAN_PHAI_CHON_IT_NHAT_1_PHUONG_THUC_DONG_THUNG'),
          this.translate.instant('CRATING_THONG_BAO_CHAM'),
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          }
        );
        return;
      }
      // Thu thập tem trực tiếp từ nguồn sự thật (success lists) thay vì listContent/codeList
      // để đảm bảo tem đã xóa không bị gửi lên server
      let allStampsSet = new Set<string>();

      // 1. Thêm tem lẻ hợp lệ từ successListStampSingle
      this.successListStampSingle.forEach(item => {
        allStampsSet.add(item.stampCode);
      });

      // 2. Thêm tem lẻ hợp lệ từ listContentTitle (modal nhập tem lẻ)
      this.listContentTitle.forEach(item => {
        if (item.acceptBox === true) {
          allStampsSet.add(item.serial);
        }
      });

      // 3. Thêm tem hợp lệ từ dải tem (successCodeListStamp)
      this.successCodeListStamp.forEach(item => {
        const rangeStampCode = `${item.prefix}-${item.idStart}-${item.idEnd}`;
        if (item.stampCode === rangeStampCode) {
          // Đây là dải tem hợp lệ hoàn toàn (stampCode dạng PREFIX-START-END)
          const startNum = parseInt(item.idStart, 10);
          const endNum = parseInt(item.idEnd, 10);
          const paddingLength = item.idStart.length;
          for (let i = startNum; i <= endNum; i++) {
            let serialString = i.toString();
            while (serialString.length < paddingLength) {
              serialString = '0' + serialString;
            }
            allStampsSet.add(`${item.prefix}-${serialString}`);
          }
        } else {
          // Đây là tem đơn lẻ trong dải (stampCode dạng PREFIX-SERIAL)
          allStampsSet.add(item.stampCode);
        }
      });
      // validate box type - bypassed for existing box
      let boxType = $('#crating_type').val();
      if (boxType === undefined || boxType === null || boxType === '') {
        boxType = 0;
      }

      // box
      let body = {};
      const allStamps = Array.from(allStampsSet);
      if (allStamps.length <= 0) {
        this.toastr.warning(this.translate.instant('CRATING_BAN_CHUA_NHAP_TEM_LE_HOAC_DAI_TEM'), this.translate.instant('CRATING_THONG_BAO_CHAM'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
        return;
      }

      body = {
        type: 1,
        stamp: allStamps,
        box_stamp: data_post.stampCode.toUpperCase(),
        boxType: Number(boxType),
        note: data_post.note,
      };
      // Removed quantityPackage checks for existing box
      // console.log('this.msgErrorTotalStamp', this.msgErrorTotalStamp)
      // return;
      // if (boxType) {
      //   let boxTypeTracking = $("#crating_type").select2('data')[0]['text'];
      //   var result = boxTypeTracking.trim();
      //   // console.log("crating", result)
      //   // let bodyTracking = {};
      //   // bodyTracking = body;
      //   // bodyTracking['boxTypeName'] = result;
      //   // console.log("crating", JSON.stringify(bodyTracking));
      //   clickTracking('qcheck_batch_manage', 'stamp_package', 'stamp_package_alert', result)
      // }

      this.cratingService.cratingBoxStamp(body).subscribe(
        (res) => {
          if (res.code === 1) {

            if (res.data !== null && res.data.acceptBoxed === false) {
              this.toastr.warning(res.data.msg, this.translate.instant('CRATING_THONG_BAO_CHAM'), {
                timeOut: 3000,
                positionClass: 'toast-top-right',
              });
              return;
            }
            this.errMess = [];
            this.warningMess = [];
            this.boxStampMessWarring = '';
            this.errorListStampSingle = [];   // [FIX QRSLK-3493] Reset tem lẻ lỗi
            this.successListStampSingle = []; // [FIX QRSLK-3493] Reset tem lẻ hợp lệ

            // [FIX QRSLK-3494] Reset dải tem lỗi & hợp lệ
            this.errorCodeListStamp = [];
            this.successCodeListStamp = [];

            this.listContent = [];
            this.removeCodeListAll();

            // Clean up manual inputs
            this.prefixInput = '';
            this.serialFirstInput = '';
            this.serialLastInput = '';

            this.formCratingBatch.get('stampCode').setValue('');
            this.formCratingBatch.get('note').setValue('');
            $('#crating_type').val('').trigger('change');
            this.toastr.success(this.translate.instant('CRATING_DONG_THUNG_THANH_CONG'), this.translate.instant('CRATING_THONG_BAO_CHAM'), {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
            this.messageCrating2.emit('Donee');
            this.reloadListStampParent.emit(data_post.note);
            $('#crating-box').modal('hide');
          } else {
            this.toastr.warning(res.message, this.translate.instant('CRATING_THONG_BAO_CHAM'), {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
          }
        },
        (err) => {
          this.toastr.warning(this.translate.instant('CRATING_DA_CO_LOI_XAY_RA'), this.translate.instant('CRATING_THONG_BAO_CHAM'), {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
        }
      );
      this.msgErrorTotalStamp = ''
    }, 1000);
  }

  cratingStampsChange() {
    if (this.formCratingBatch.value.is_cratingStampsSingle === false) {
      this.listContent = [];
    }

    if (this.formCratingBatch.value.is_cratingStampsList === false) {
      this.removeCodeListAll();
    }
  }

  // boxRetalStamps
  async removeItem(index) {
    this.listContent = this.listContent.filter((res, i) => i !== index);
    this.listContentTitle = this.listContentTitle.filter((res, i) => i !== index);
    this.stampList = this.stampList.filter((res, i) => i !== index);
    await this.checkStampValidate();
    this.calculateTotalStamp()
  }

  showModal() {
    const data = {
      id: 'myModalCrating',
      title: this.translate.instant('THEM_DANH_SACH_TEM_LE'),
      contentMess: this.translate.instant('CRATING_BAN_CHUA_NHAP_TEM_LE'),
      listContent: this.listContent,
    };
    this.boxRetalStamps.show(data);

  }

  async loadDataChild(e) {
    const stampList = [];
    e.forEach((res) => {
      let splitSerial = res.split('-');
      let _serial: any = '';
      let _prefix: any = '';
      if (splitSerial.length > 1) {
        _serial = splitSerial.pop();
        _prefix = splitSerial[0];
        console.log(_serial, _prefix);
      } else {
        _serial = NaN;
        _prefix = splitSerial[0];
      }
      const stamp = {
        prefix: _prefix,
        serialFirst: _serial,
        serialLast: _serial,
      };
      stampList.push(stamp);
    });
    this.stampList = stampList;
    // this.checktemp();
    this.listContent = e;
    await this.checkStampValidate();
    this.calculateTotalStamp()
  }

  async checkStampValidate() {
    console.log(23434)
    this.errMess = [this.translate.instant('CRATING_DANG_KIEM_TRA')];
    const query = {
      stamps: this.listContent.toString(),
      type: 1,
    };
    const errMess = [];
    const warningMess = [];
    const tempListContentTitle = []; // Mảng tạm để lưu dữ liệu tiêu đề mới

    if (this.listContent.length > 0) {
      this.cratingService.stampValidate(query).subscribe(
        (res) => {
          if (res.code === 1) {
            res.data.map((val) => {
              // Đẩy vào tempListContentTitle với định dạng {serial: stampCode, msgErr: msg}
              tempListContentTitle.push({
                serial: val.stampCode,
                msgErr: val.msg,
                acceptBox: val.acceptBoxed
              });

              if (val.status !== 1) {
                if (val.acceptBoxed === true) {
                  warningMess.push(val.msg);
                } else {
                  errMess.push(val.msg);
                }
              }
            });
            this.warningMess = warningMess.length > 0 ? warningMess : [];
            this.errMess = errMess.length > 0 ? errMess : [];
          } else {
            // Trường hợp res.code !== 1
            this.listContent.forEach((stamp) => {
              tempListContentTitle.push({
                serial: stamp,
                msgErr: res.message || this.translate.instant('CRATING_DA_CO_LOI_XAY_RA'), // Sử dụng res.message nếu có, nếu không thì mặc định
                acceptBox: res.acceptBoxed
              });
            });
            this.errMess = [res.message];
            this.warningMess = [];
          }
          this.listContentTitle = [...tempListContentTitle];
          this.calculateTotalStamp();
        },
        (err) => {
          // Xử lý trường hợp lỗi
          this.listContent.forEach((stamp) => {
            tempListContentTitle.push({
              serial: stamp,
              msgErr: err.message || this.translate.instant('CRATING_DA_CO_LOI_XAY_RA'),
            });
          });
          if (err && err.message) {
            this.errMess = [];
            this.errMess.push(err.message)
          } else {
            this.errMess = [this.translate.instant('CRATING_DA_CO_LOI_XAY_RA')];
          }
          this.warningMess = [];
          this.calculateTotalStamp();
        }
      );
    } else {
      this.errMess = [];
      this.warningMess = [];
      this.listContentTitle = []
      this.calculateTotalStamp();
    }
  }

  // end boxRetalStamps
  // codeList
  isNaN(x) {
    // Ép kiểu Number cho biến x
    x = Number(x);
    // Nếu x là NaN, NaN != NaN trả về true, các trường hợp khác sẽ trả về false
    return x != x;
  }

  codeList(): FormArray {
    return this.formCratingBatch.get('stampCodeList') as FormArray;
  }

  newCodeList(): FormGroup {
    return this.fb.group({
      prefix: '',
      serialFirst: '',
      serialLast: '',
      data: null,
      title: '',
      isReadmore: false,
      acceptBoxed: null,
    });
  }

  addCodeList() {
    this.codeList().push(this.newCodeList());
  }

  removeCodeList(i: number) {
    const item = this.codeList().at(i).value;
    this.errorCodeListStamp = this.errorCodeListStamp.filter(err => 
      !(err.prefix == item.prefix && err.idStart == item.serialFirst && err.idEnd == item.serialLast)
    );
    this.successCodeListStamp = this.successCodeListStamp.filter(succ => 
      !(succ.prefix == item.prefix && succ.idStart == item.serialFirst && succ.idEnd == item.serialLast)
    );

    this.codeList().removeAt(i);
    this.calculateTotalStamp()
    // this.checktemp();
  }

  removeCodeListAll() {
    while (this.codeList().length !== 0) {
      this.codeList().removeAt(0);
    }
    this.errorCodeListStamp = [];
    this.successCodeListStamp = [];
  }

  // ===== TEM LẺ: methods xóa =====
  removeErrorListStampSingle(index: number) {
    const stamp = this.errorListStampSingle[index];
    if (stamp) this.removeFromListContentAndTitle(stamp.stampCode);
    this.errorListStampSingle.splice(index, 1);
    this.calculateTotalStamp();
  }

  removeSuccessListStampSingle(index: number) {
    const stamp = this.successListStampSingle[index];
    if (stamp) this.removeFromListContentAndTitle(stamp.stampCode);
    this.successListStampSingle.splice(index, 1);
    this.calculateTotalStamp();
  }

  clearErrorListStampSingle() {
    this.errorListStampSingle.forEach(stamp => this.removeFromListContentAndTitle(stamp.stampCode));
    this.errorListStampSingle = [];
    this.calculateTotalStamp();
  }

  clearSuccessListStampSingle() {
    this.successListStampSingle.forEach(stamp => this.removeFromListContentAndTitle(stamp.stampCode));
    this.successListStampSingle = [];
    this.calculateTotalStamp();
  }

  private removeFromListContentAndTitle(stampCode: string) {
    const idx = this.listContent.indexOf(stampCode);
    if (idx !== -1) {
      this.listContent.splice(idx, 1);
    }
    const idxTitle = this.listContentTitle.findIndex(t => t.serial === stampCode);
    if (idxTitle !== -1) {
      this.listContentTitle.splice(idxTitle, 1);
    }
  }

  // ===== TEM LẺ: thêm tem lẻ & validate =====
  // (Tham khảo: boxStampDistribution.component.ts dòng 3673-3797)
  addStampSingle() {
    const rawInput = this.addContent.trim();
    if (!rawInput) {
      return;
    }

    // Parse textarea: split theo dòng mới, uppercase, trim, loại bỏ dòng trống
    const stampCodes = rawInput
      .toUpperCase()
      .split('\n')
      .map(s => s.trim())
      .filter(s => s.length > 0);

    if (stampCodes.length === 0) {
      return;
    }

    // Chỉ check trùng với tem hợp lệ (success) ở Tem lẻ Và Dải tem
    const existingValidCodes = new Set(this.successListStampSingle.map(s => s.stampCode));
    // Thêm các tem hợp lệ từ dải tem vào tập hợp check trùng
    this.successCodeListStamp.forEach(item => existingValidCodes.add(item.stampCode));
    // Thêm các tem hợp lệ từ listContentTitle
    this.listContentTitle.forEach(item => {
      if (item.serial && item.acceptBox) existingValidCodes.add(item.serial);
    });
    // Thêm các tem hợp lệ từ codeList (dải tem chưa có chi tiết - tức API không trả mảng data)
    this.codeList().controls.forEach(control => {
      const val = control.value;
      if (val.acceptBox === true && !val.data && val.prefix && val.serialFirst && val.serialLast) {
        const prefix = val.prefix.trim().toUpperCase();
        const start = parseInt(val.serialFirst, 10);
        const end = parseInt(val.serialLast, 10);
        for (let n = start; n <= end; n++) {
          let s = n.toString();
          while (s.length < val.serialFirst.length) { s = '0' + s; }
          existingValidCodes.add(prefix + '-' + s);
        }
      }
    });
    const seenInInput = new Set<string>();
    
    const newStampCodes = [];
    let hasDuplicate = false;

    stampCodes.forEach(code => {
      // Check trùng với tem hợp lệ hoặc trùng trong cùng input
      if (existingValidCodes.has(code) || seenInInput.has(code)) {
        hasDuplicate = true;
        this.errorListStampSingle.push({
          stampCode: code,
          msg: 'Tem bị trùng',
          acceptBoxed: false,
        });
        return;
      }

      seenInInput.add(code);
      newStampCodes.push(code);
    });

    if (hasDuplicate) {
      this.toastr.warning(
        'Tem đã tồn tại trong danh sách',
        this.translate.instant('CRATING_THONG_BAO_CHAM'),
        { timeOut: 3000, positionClass: 'toast-top-right' }
      );
    }

    if (newStampCodes.length === 0) {
      this.addContent = '';
      this.calculateTotalStamp();
      return;
    }

    // Gọi API validate tem lẻ
    const query = {
      stamps: newStampCodes.toString(),
      type: 1,
    };

    this.cratingService.stampValidate(query).subscribe(
      (res) => {
        if (res.code === 1) {
          res.data.forEach((item) => {
            const entry = {
              stampCode: item.stampCode,
              msg: item.msg,
              acceptBoxed: item.acceptBoxed,
            };
            if (item.acceptBoxed === false) {
              this.errorListStampSingle.push(entry);
            } else {
              // Check trùng với tem đã có trong success list trước khi thêm
              const isDup = this.successListStampSingle.some(s => s.stampCode === item.stampCode)
                         || this.successCodeListStamp.some(s => s.stampCode === item.stampCode);
              if (isDup) {
                entry.msg = 'Tem bị trùng';
                entry.acceptBoxed = false;
                this.errorListStampSingle.push(entry);
              } else {
                this.successListStampSingle.push(entry);
                // Thêm vào listContent cho logic submit
                if (!this.listContent.includes(item.stampCode)) {
                  this.listContent.push(item.stampCode);
                }
              }
            }
          });
        } else {
          // API trả lỗi: đẩy tất cả vào error
          newStampCodes.forEach(code => {
            this.errorListStampSingle.push({
              stampCode: code,
              msg: res.message || this.translate.instant('CRATING_DA_CO_LOI_XAY_RA'),
              acceptBoxed: false,
            });
          });
        }
        this.calculateTotalStamp();
      },
      (err) => {
        newStampCodes.forEach(code => {
          this.errorListStampSingle.push({
            stampCode: code,
            msg: err && err.message ? err.message : this.translate.instant('CRATING_DA_CO_LOI_XAY_RA'),
            acceptBoxed: false,
          });
        });
        this.calculateTotalStamp();
      }
    );

    // Clear textarea
    this.addContent = '';
  }

  // ===== DẢI TEM: methods xóa =====
  removeErrorCodeListStamp(index: number) {
    const arrStampError = this.errorCodeListStamp[index];
    
    // Chỉ xóa entry lỗi cụ thể này (không xóa toàn bộ dải)
    this.errorCodeListStamp.splice(index, 1);
    
    // Kiểm tra xem còn lỗi nào cho cùng dải tem không
    const hasRemainingErrors = this.errorCodeListStamp.some(err => 
      err.prefix === arrStampError.prefix && 
      parseInt(err.idStart, 10) === parseInt(arrStampError.idStart, 10) && 
      parseInt(err.idEnd, 10) === parseInt(arrStampError.idEnd, 10)
    );
    
    // Nếu không còn lỗi nào cho dải này, cập nhật acceptBox = true để cho phép submit
    if (!hasRemainingErrors) {
      const idx = this.codeList().controls.findIndex(control => {
        const item = control.value;
        return item.prefix === arrStampError.prefix && 
               parseInt(item.serialFirst, 10) === parseInt(arrStampError.idStart, 10) && 
               parseInt(item.serialLast, 10) === parseInt(arrStampError.idEnd, 10);
      });
      if (idx !== -1) {
        this.codeList().at(idx).patchValue({ acceptBox: true, title: '' });
      }
    }
    
    this.calculateTotalStamp();
  }

  removeSuccessCodeListStamp(index: number) {
    const arrStampSuccess = this.successCodeListStamp[index];
    const idx = this.codeList().controls.findIndex(control => {
      const item = control.value;
      return item.prefix === arrStampSuccess.prefix && 
             parseInt(item.serialFirst, 10) === parseInt(arrStampSuccess.idStart, 10) && 
             parseInt(item.serialLast, 10) === parseInt(arrStampSuccess.idEnd, 10);
    });
    if (idx !== -1) {
      this.codeList().removeAt(idx);
    }
    
    this.successCodeListStamp = this.successCodeListStamp.filter(succ => 
      !(succ.prefix === arrStampSuccess.prefix && 
        parseInt(succ.idStart, 10) === parseInt(arrStampSuccess.idStart, 10) && 
        parseInt(succ.idEnd, 10) === parseInt(arrStampSuccess.idEnd, 10))
    );
    this.errorCodeListStamp = this.errorCodeListStamp.filter(err => 
      !(err.prefix === arrStampSuccess.prefix && 
        parseInt(err.idStart, 10) === parseInt(arrStampSuccess.idStart, 10) && 
        parseInt(err.idEnd, 10) === parseInt(arrStampSuccess.idEnd, 10))
    );
    this.calculateTotalStamp();
  }

  clearErrorCodeListStamp() {
    // Lấy danh sách các dải tem duy nhất bị ảnh hưởng
    const affectedRanges = [];
    this.errorCodeListStamp.forEach(err => {
      const exists = affectedRanges.some(r => 
        r.prefix === err.prefix && 
        parseInt(r.idStart, 10) === parseInt(err.idStart, 10) && 
        parseInt(r.idEnd, 10) === parseInt(err.idEnd, 10)
      );
      if (!exists) {
        affectedRanges.push({ prefix: err.prefix, idStart: err.idStart, idEnd: err.idEnd });
      }
    });
    
    // Xóa tất cả lỗi
    this.errorCodeListStamp = [];
    
    // Cập nhật acceptBox = true cho các dải tem không còn lỗi
    affectedRanges.forEach(range => {
      const idx = this.codeList().controls.findIndex(control => {
        const item = control.value;
        return item.prefix === range.prefix && 
               parseInt(item.serialFirst, 10) === parseInt(range.idStart, 10) && 
               parseInt(item.serialLast, 10) === parseInt(range.idEnd, 10);
      });
      if (idx !== -1) {
        this.codeList().at(idx).patchValue({ acceptBox: true, title: '' });
      }
    });
    
    this.calculateTotalStamp();
  }

  clearSuccessCodeListStamp() {
    this.successCodeListStamp.forEach(arrStampSuccess => {
      const idx = this.codeList().controls.findIndex(control => {
        const item = control.value;
        return item.prefix === arrStampSuccess.prefix && 
               parseInt(item.serialFirst, 10) === parseInt(arrStampSuccess.idStart, 10) && 
               parseInt(item.serialLast, 10) === parseInt(arrStampSuccess.idEnd, 10);
      });
      if (idx !== -1) {
        this.codeList().removeAt(idx);
      }
    });
    this.successCodeListStamp = [];
    this.calculateTotalStamp();
  }

  // ===== DẢI TEM: thêm dải tem & validate =====
  addStampCodeListAndValidate() {
    const prefix = this.prefixInput.trim();
    const serialFirst = this.serialFirstInput.trim();
    const serialLast = this.serialLastInput.trim();

    if (!prefix || !serialFirst || !serialLast) {
      this.toastr.warning(
        this.translate.instant('CRATING_VUI_LONG_NHAP_DAY_DU'),
        this.translate.instant('CRATING_THONG_BAO_CHAM'),
        { timeOut: 3000, positionClass: 'toast-top-right' }
      );
      return;
    }

    if (parseInt(serialFirst) > parseInt(serialLast)) {
      this.toastr.warning(
        this.translate.instant('CRATING_SERIAL_CUOI_PHAI_LON_HON_SERIAL_DAU'),
        this.translate.instant('CRATING_THONG_BAO_CHAM'),
        { timeOut: 3000, positionClass: 'toast-top-right' }
      );
      return;
    }

    // Thêm vào FormArray để tương thích submit logic
    this.codeList().push(this.fb.group({
      prefix: prefix,
      serialFirst: serialFirst,
      serialLast: serialLast,
      data: null,
      title: '',
      isReadmore: false,
      acceptBoxed: null,
      acceptBox: null,
      totalStamp: 0
    }));

    const i = this.codeList().length - 1;

    // Gọi API validate
    const query = {
      type: 2,
      prefix: prefix.toUpperCase(),
      start: serialFirst,
      end: serialLast,
    };

    // @ts-ignore
    this.cratingService.stampGroupValidate(query).subscribe(
      (res) => {
        const currentControl = this.codeList().at(i);
        const prefixUpper = prefix.toUpperCase();
        if (res.code === 1) {
          if (res.data && res.data.length > 0) {
            let countNewValid = 0;
            res.data.forEach(item => {
              const entry = {
                prefix: prefixUpper,
                idStart: serialFirst,
                idEnd: serialLast,
                stampCode: item.stampCode,
                msg: item.msg,
                errorMessage: item.msg,
                warningMessage: item.msg,
                acceptBoxed: item.acceptBoxed,
              };
              if (item.acceptBoxed === false) {
                this.errorCodeListStamp.push(entry);
              } else {
                const isDup = this.successCodeListStamp.some(s => s.stampCode === item.stampCode)
                           || this.successListStampSingle.some(s => s.stampCode === item.stampCode);
                if (isDup) {
                  // Tem hợp lệ nhưng bị trùng → đẩy vào lỗi
                  entry.msg = 'Tem bị trùng';
                  entry.errorMessage = 'Tem bị trùng';
                  entry.acceptBoxed = false;
                  this.errorCodeListStamp.push(entry);
                } else {
                  this.successCodeListStamp.push(entry);
                  countNewValid++;
                }
              }
            });

            // Cập nhật acceptBox cho FormArray item
            const allAccepted = res.data.every(item => item.acceptBoxed === true);
            currentControl.patchValue({
              acceptBox: allAccepted,
              data: res.data,
              totalStamp: countNewValid
            });
          } else {
            currentControl.patchValue({
              acceptBox: true,
              data: null,
              totalStamp: parseInt(serialLast) - parseInt(serialFirst) + 1
            });
          }
        } else {
          const entry = {
            prefix: prefixUpper,
            idStart: serialFirst,
            idEnd: serialLast,
            stampCode: prefixUpper + '-' + serialFirst + '-' + serialLast,
            msg: res.message,
            errorMessage: res.message,
            acceptBoxed: false,
          };
          this.errorCodeListStamp.push(entry);
          currentControl.patchValue({ acceptBox: false });
        }
        this.calculateTotalStamp();
      },
      (err) => {
        const entry = {
          prefix: prefix.toUpperCase(),
          idStart: serialFirst,
          idEnd: serialLast,
          stampCode: prefix.toUpperCase() + '-' + serialFirst + '-' + serialLast,
          msg: this.translate.instant('CRATING_DA_CO_LOI_XAY_RA'),
          errorMessage: this.translate.instant('CRATING_DA_CO_LOI_XAY_RA'),
          acceptBoxed: false,
        };
        this.errorCodeListStamp.push(entry);
      }
    );

    // Clear inputs
    this.prefixInput = '';
    this.serialFirstInput = '';
    this.serialLastInput = '';
  }

  stampCodeChanged(i) {
    if (
      this.formCratingBatch.value.stampCodeList[i].prefix.trim() !== '' &&
      this.formCratingBatch.value.stampCodeList[i].serialFirst.trim() !== '' &&
      this.formCratingBatch.value.stampCodeList[i].serialLast.trim() !== ''
    ) {
      this.formCratingBatch.value.stampCodeList[i].title = this.translate.instant('CRATING_DANG_KIEM_TRA');
      this.formCratingBatch.value.stampCodeList[i].totalStamp =
        // tslint:disable-next-line:max-line-length
        parseInt(this.formCratingBatch.value.stampCodeList[i].serialLast.trim()) - parseInt(this.formCratingBatch.value.stampCodeList[i].serialFirst.trim()) + 1
      if (
        parseInt(
          this.formCratingBatch.value.stampCodeList[i].serialFirst.trim()
        ) >
        parseInt(this.formCratingBatch.value.stampCodeList[i].serialLast.trim())
      ) {
        this.formCratingBatch.value.stampCodeList[i].title =
          this.translate.instant('CRATING_SERIAL_CUOI_PHAI_LON_HON_SERIAL_DAU');
      } else {
        // this.checktemp();
        const query = {
          type: 2,
          prefix: this.formCratingBatch.value.stampCodeList[i].prefix
            .trim()
            .toUpperCase(),
          start: this.formCratingBatch.value.stampCodeList[
            i
          ].serialFirst.trim(),
          end: this.formCratingBatch.value.stampCodeList[i].serialLast.trim(),
        };
        // @ts-ignore
        this.cratingService.stampGroupValidate(query).subscribe(
          (res) => {
            const currentControl = this.codeList().at(i);
            const prefixUpper = currentControl.value.prefix.trim().toUpperCase();
            const serialFirst = currentControl.value.serialFirst.trim();
            const serialLast = currentControl.value.serialLast.trim();
            if (res.code === 1) {
              if (!res.data || res.data.length === 0) {
                currentControl.patchValue({
                  data: null,
                  title: '',
                  acceptBox: true
                });
              } else {
                let countNewValid = 0;
                // Thêm kết quả vào danh sách hiển thị
                res.data.forEach(item => {
                  const entry = {
                    prefix: prefixUpper,
                    idStart: serialFirst,
                    idEnd: serialLast,
                    stampCode: item.stampCode,
                    msg: item.msg,
                    errorMessage: item.msg,
                    warningMessage: item.msg,
                    acceptBoxed: item.acceptBoxed,
                  };
                  if (item.acceptBoxed === false) {
                    this.errorCodeListStamp.push(entry);
                  } else {
                    const isDup = this.successCodeListStamp.some(s => s.stampCode === item.stampCode) 
                               || this.successListStampSingle.some(s => s.stampCode === item.stampCode);
                    if (isDup) {
                      // Tem hợp lệ nhưng bị trùng → đẩy vào lỗi
                      entry.msg = 'Tem bị trùng';
                      entry.errorMessage = 'Tem bị trùng';
                      entry.acceptBoxed = false;
                      this.errorCodeListStamp.push(entry);
                    } else {
                      this.successCodeListStamp.push(entry);
                      countNewValid++;
                    }
                  }
                });

                // API v2: res.data là array ValidateStampResult[]
                // Kiểm tra toàn bộ mảng: nếu có bất kỳ tem nào không acceptBoxed → cả dải lỗi
                const allAccepted = res.data.every(item => item.acceptBoxed === true);
                const errorItems = res.data.filter(item => item.acceptBoxed === false);

                if (!allAccepted) {
                  // Tổng hợp message lỗi từ tất cả tem lỗi
                  const errorMessages = errorItems.map(item => item.stampCode + ': ' + item.msg);
                  currentControl.patchValue({
                    title: errorMessages.join('; '),
                    acceptBox: false,
                    data: res.data,
                    totalStamp: countNewValid
                  });
                } else {
                  // Tất cả hợp lệ - hiển thị message từ response level hoặc item đầu tiên
                  currentControl.patchValue({
                    title: res.message || '',
                    acceptBox: true,
                    data: res.data,
                    totalStamp: countNewValid
                  });
                }
              }
            } else {
              currentControl.patchValue({
                title: res.message || null,
                acceptBox: null,
                data: null
              });
              
              const entry = {
                prefix: prefixUpper,
                idStart: serialFirst,
                idEnd: serialLast,
                stampCode: prefixUpper + '-' + serialFirst + '-' + serialLast,
                msg: res.message,
                errorMessage: res.message,
                acceptBoxed: false,
              };
              this.errorCodeListStamp.push(entry);
            }
            console.log(currentControl.value);
            console.log('vao day ko')
            this.calculateTotalStamp()
          },
          (err) => {
            const currentControl = this.codeList().at(i);
            currentControl.patchValue({
              title: this.translate.instant('CRATING_DA_CO_LOI_XAY_RA')
            });
          }
        );
      }
    }
  }

  checkTripNumber(item, itemFirst, itemLast) {
    return itemFirst <= item && item <= itemLast;
  }
  // end codeList

  searchCode() {
    this.boxStampMess = this.translate.instant('CRATING_DANG_KIEM_TRA');
    let query: any = null;
    if (
      this.formCratingBatch.value.stampCode &&
      this.formCratingBatch.value.stampCode.trim()
    ) {
      query = {
        box_stamp: this.formCratingBatch.value.stampCode.trim().toUpperCase(),
      };
    }
    if (this.formCratingBatch.value.stampCode.length > 0 && query) {
      const code = this.formCratingBatch.value.stampCode.trim().toUpperCase();
      let splitSerial = code.split('-');
      let _serial: any = '';
      let _prefix: any = '';
      if (splitSerial.length > 1) {
        _serial = splitSerial.pop();
        _prefix = splitSerial.join('-');
      } else {
        _serial = NaN;
        _prefix = splitSerial.join('-');
      }

      const isOverlapRange = this.successCodeListStamp.some(item => 
        item.prefix === _prefix && 
        parseInt(_serial) >= parseInt(item.idStart) && 
        parseInt(_serial) <= parseInt(item.idEnd)
      ) || this.errorCodeListStamp.some(item => 
        item.prefix === _prefix && 
        parseInt(_serial) >= parseInt(item.idStart) && 
        parseInt(_serial) <= parseInt(item.idEnd)
      );

      const isDuplicateWithSingle = this.successListStampSingle.some(item => {
        let singleSplit = item.stampCode.split('-');
        let singleSerial: any = '';
        let singlePrefix: any = '';
        if (singleSplit.length > 1) {
          singleSerial = singleSplit.pop();
          singlePrefix = singleSplit.join('-');
        } else {
          singleSerial = NaN;
          singlePrefix = singleSplit.join('-');
        }
        return singlePrefix === _prefix && parseInt(singleSerial) === parseInt(_serial);
      });

      if (isOverlapRange || isDuplicateWithSingle) {
        this.toastr.warning(
          'Đã nằm trong dải tem hoặc tem lẻ gửi lên',
          this.translate.instant('CRATING_THONG_BAO_CHAM'),
          { timeOut: 3000, positionClass: 'toast-top-right' }
        );
        this.formCratingBatch.patchValue({ stampCode: '' });
        this.boxStampMess = '';
        this.boxStampMessWarring = '';
        return;
      }


      this.cratingService.boxValidate(query).subscribe(
        (res) => {
          if (res.code === 1) {
            if (res.data !== null && res.data.acceptBoxed === false) {
              this.boxStampMess = res.data.msg;
              this.boxStampMessWarring = '';

              return;
            }

            if (res.data !== null && res.data.acceptBoxed === true) {
              this.boxStampMessWarring = res.data.msg;
              this.boxStampMess = '';

              return;
            }
            this.boxStampMess = '';
            this.boxStampMessWarring = '';
          } else {
            this.boxStampMess = res.message;
            this.boxStampMessWarring = '';
          }
        },
        (err) => {
          this.boxStampMess =
            err && err.message ? err.message : this.translate.instant('CRATING_DA_CO_LOI_XAY_RA');
          this.boxStampMessWarring = '';
        }
      );
    } else {
      this.boxStampMess = '';
      this.boxStampMessWarring = '';
    }
  }

  // Tuanba: 5-8-2025: Tuanba validate phần số lượng tem đóng gói
  public totalStamp = 0
  public msgErrorTotalStamp = ''

  calculateTotalStamps(data) {
    console.log('daattatatat ', data)
    console.log('totalStamp ', this.totalStamp)
    // Lấy tổng từ stampGrounp
    const stampGroupTotal = data.stampGrounp ? data.stampGrounp.reduce((sum, group) => sum + group.totalScopeStamp, 0) : 0;
    // Lấy số lượng stamp
    const stampCount = data.stamp ? data.stamp.length : 0;
    // Tính tổng
    return stampGroupTotal + stampCount;
  }

  preventNonNumber(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    // Cho phép: phím số (0–9) và phím điều khiển (backspace, delete)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault(); // Chặn phím không hợp lệ
    }
  }

  onChangeQuantityStampPackage(e) {
    this.formCratingBatch.value.quantityPackage = e.target.value
    this.calculateTotalStamp()
    setTimeout(() => {
      const element = document.querySelector('.page-create-item');
      console.log('element22222', element);
      if (element && this.msgErrorTotalStamp != '') {
        element.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        console.warn('Phần tử page-create-item không tồn tại');
      }
    }, 0);
  }

  onChangeErrorTotalStamp(first, second) {
    if (second) {
      this.msgErrorTotalStamp = first > second ? this.translate.instant('CRATING_DA_VUOT_QUA_SO_LUONG_TEM_YEU_CAU') : '';
    } else {
      this.msgErrorTotalStamp = ''
    }
  }

  // Hàm tính tổng số lượng tem nhập vào
  calculateTotalStamp() {
    // Tính tổng tem lẻ hợp lệ (gộp từ textarea và modal để tránh trùng lặp hoặc mất dữ liệu khi xóa)
    const uniqueValidSingleStamps = new Set<string>();
    this.successListStampSingle.forEach(item => uniqueValidSingleStamps.add(item.stampCode));
    this.listContentTitle.forEach(item => {
      if (item.acceptBox) {
        uniqueValidSingleStamps.add(item.serial);
      }
    });
    let totalStamp = uniqueValidSingleStamps.size;

    // Tính tổng dải tem hợp lệ từ successCodeListStamp (nguồn sự thật)
    const countedRanges = new Set<string>();
    this.successCodeListStamp.forEach(item => {
      const rangeStampCode = `${item.prefix}-${item.idStart}-${item.idEnd}`;
      if (item.stampCode === rangeStampCode) {
        // Dải tem hợp lệ hoàn toàn (không có chi tiết từ API)
        if (!countedRanges.has(rangeStampCode)) {
          countedRanges.add(rangeStampCode);
          totalStamp += parseInt(item.idEnd, 10) - parseInt(item.idStart, 10) + 1;
        }
      } else {
        // Tem đơn lẻ trong dải (có chi tiết từ API) - đếm từng tem
        totalStamp += 1;
      }
    });

    this.totalStamp = totalStamp; // Cập nhật totalStamp
    
    const slg_dong_goi_thieu = parseInt(this.formCratingBatch.value.quantityPackage || 0);
    if (totalStamp > slg_dong_goi_thieu && slg_dong_goi_thieu > 0) {
      this.msgErrorTotalStamp = this.translate.instant('CRATING_SO_LUONG_NHAP_VUOT_QUA_YEU_CAU', { total: totalStamp, required: slg_dong_goi_thieu });
    } else {
      this.msgErrorTotalStamp = '';
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/stamp_list/stamp-box/modal-crating-box/modal-crating-box.component.ts